import React, { useEffect, useState } from 'react'
import SideMenu from 'Components/SideMenuRefactored/SideMenu'
import { Grid, Box, Divider } from '@mui/material'
import StickyHeadTable from 'Components/MpHomeRefactor/MpTable/MpTable'
import { getIds } from 'Components/ReusableComponents.js/getIds'
import { makeLogRequest } from 'utils/AuditLogs'
import './AdminHome.css'
import LeaderBoardTabs from 'Components/MpHomeRefactor/LeaderBoardTabs/LeaderBoardTabs'
import MpCard from 'Components/MpHomeRefactor/MpCard/MpCard'
import HighlightsSection from 'Components/MpHomeRefactor/HighlightsSection/HighlightsSection'
import 'Components/ReusableComponents.js/reusableIndex.css'
import LeaderBoardHeader from 'Components/MpHomeRefactor/LeaderBoardHeader/LeaderBoardHeader'
import NotificationsList from 'Components/ReusableComponents.js/NotificationList/NotificationsList'
import { useLoading } from '../../utils/LoadingContext'
import { useDispatch, useSelector } from 'react-redux'
import { getLeaderboardTabs } from 'store/action/leaderboardTabs'
import { getMpProfile } from 'store/action/individualMP'
import EngagementTable from 'Components/MpHomeRefactor/MpTable/EngagementTable'
const loggedInId = getIds()
const AdminHome = () => {
  const isBdayCampaignEnabled = JSON.parse(localStorage.getItem('isBdayCampaignEnabled') || false)
  //const isSurveyCampaignEnabled = JSON.parse(localStorage.getItem('isSurveyCampaignEnabled') || false)
  const lastData = JSON.parse(localStorage.getItem('leaderBoardSelectedItem') || '{}')
  const { tabId, card, flag, scrollDirection } = lastData
  const [selectedCard, setSelectedCard] = useState()
  const [Flag, setFlag] = useState(flag ? flag : '101')
  const [dataFilter, setDataFilter] = useState('15days')
  const [defaultVal, setDefaultVal] = useState('15days')
  const [tenure, setCurrentTenure] = useState('Modi3.0')
  const [defaultTenure, setTenure] = useState('Modi3.0')

  const [isMarqueeVisible, setIsMarqueeVisible] = useState(false)
  const [cardLoading, setCardLoading] = useState(false)
  const [highlightsLoading, setHighlightsLoading] = useState(false)
  const [onTableLoad, setTableLoad] = useState(false)
  const { setLoading } = useLoading()
  const scrollRef = React.useRef()
  const handleScroll = () => {
    scrollRef.current.scrollTop = 0
  }
  const dispatch = useDispatch()
  const tabs = useSelector((state) => state?.leaderboardtabs?.data?.tabs)
  const [tabsData, setTabData] = useState([])
  useEffect(() => {
    dispatch(getLeaderboardTabs())
    const pageLoad = async () => {
      const parameters = {
        useridtype: getIds(),
        section: selectedCard,
      }
      await makeLogRequest('mp_leaderboard', 'pageload', parameters)
    }
    if (selectedCard?.value) {
      pageLoad()
    }
  }, [])
  useEffect(() => {
    const isLoading = cardLoading || highlightsLoading || onTableLoad
    if (isLoading) {
      setLoading(true)
    } else {
      const loaderTimer = setTimeout(() => {
        setLoading(false)
      }, 400)
      return () => clearTimeout(loaderTimer)
    }
  }, [cardLoading, highlightsLoading, onTableLoad])

  useEffect(() => {
    if (tabsData?.length > 0) {
      try {
        const savedTab = localStorage.getItem('activetab')
        const parsedTab = savedTab && savedTab !== 'undefined' ? JSON.parse(savedTab) : null

        const isValidTab = parsedTab && tabsData.some((tab) => tab?.id === parsedTab?.id)

        const tabToSet = isValidTab ? parsedTab : tabsData[0]

        localStorage.setItem('activetab', JSON.stringify(tabToSet))
        setSelectedCard(tabToSet)
      } catch (error) {
        console.error('Error parsing saved tab:', error)
        const fallbackTab = tabsData[0]
        localStorage.setItem('activetab', JSON.stringify(fallbackTab))
        setSelectedCard(fallbackTab)
      }
    }
  }, [tabsData])

  useEffect(() => {
    if (!tabs) return
    const filteredTabs = tabs.map((item) => {
      let updatedItem = { ...item }

      if (updatedItem?.hasOwnProperty('tabName')) {
        updatedItem.tabTitle = updatedItem?.tabName
      }
      return updatedItem
    })
    setTabData(filteredTabs)
  }, [tabs])

  return (
    <Box className="page-wrapper d-flex">
      <SideMenu activeTab={'Leader'} />
      <Box className="main-wrapper customscroll adminhome-container" ref={scrollRef}>
        <NotificationsList setIsMarqueeVisible={setIsMarqueeVisible} isMarqueeVisible={isMarqueeVisible} />

        <Grid container className="adminHomeContainer">
          <Grid md={8} lg={8} xl={8} xs={10}>
            <LeaderBoardHeader
              title={'Leaderboard'}
              selectedCard={selectedCard}
              setDataFilter={setDataFilter}
              dataFilter={dataFilter}
              isMarqueeVisible={isMarqueeVisible}
              defaultVal={defaultVal}
              setDefaultVal={setDefaultVal}
              setCurrentTenure={setCurrentTenure}
              flag={flag}
              setTenure={setTenure}
              defaultTenure={defaultTenure}
            />
            <LeaderBoardTabs
              setCardLoading={setCardLoading}
              dataFilter={dataFilter}
              setSelectedCard={setSelectedCard}
              flag={Flag}
              setFlag={setFlag}
              selectedCard={selectedCard}
              tenure={tenure}
              tabsData={tabsData}
              setTabData={setTabData}
            />
            <Divider className="mt-2 mb-4" />
            <MpCard selectedCard={selectedCard} flag={flag} />
            <Box className="mt-5 learders-list">
              {!selectedCard?.hasOwnProperty('csvPath') ? (
                <Box className="mt-5 learders-list">
                  <StickyHeadTable
                    setTableLoad={setTableLoad}
                    selectedCard={selectedCard}
                    flag={Flag}
                    dataFilter={dataFilter}
                    tenure={tenure}
                  />
                </Box>
              ) : (
                <EngagementTable setTableLoad={setTableLoad} selectedCard={selectedCard} flag={Flag} />
              )}
            </Box>
          </Grid>
          <Grid md={6} lg={4} xl={4} sx={{ pl: '16px' }}>
            <HighlightsSection
              dataFilter={dataFilter}
              isMarqueeVisible={isMarqueeVisible}
              handleScroll={handleScroll}
              setHighlightsLoading={setHighlightsLoading}
              tenure={tenure}
            />
          </Grid>
        </Grid>
      </Box>
    </Box>
  )
}

export default AdminHome
